import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	accordionElement: 'js-m-accordion-element',
	trigger: 'js-m-accordion-element__trigger',
	activeState: 'state-m-accordion-element--active',
	doNotClose: 'js-m-accordion--donotclose',
};

@createModule('Accordion')
/**
 * Accordion module implementation.
 *
 * @author Lars-Olof Kreim <lars-olof.kreim@namics.com>
 */
export class Accordion extends TerrificSpec {
	$ctx: JQuery;
	$accordionElements: JQuery;
	doNotClose: boolean;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.$accordionElements = this.$ctx.find(`.${classes.accordionElement}`);
		this.doNotClose = this.$ctx.hasClass(classes.doNotClose);
		this.$ctx.find(`.${classes.trigger}`).on('click', this.onTriggerClick.bind(this));
		resolve();
	}

	onTriggerClick(ev: Event) {
		const $accordionElement = $(ev.currentTarget).closest(`.${classes.accordionElement}`) as JQuery;
		$accordionElement.toggleClass(classes.activeState);
		if (!this.doNotClose) {
			this.$accordionElements.not($accordionElement).removeClass(classes.activeState);
		}
		$(window).trigger('NavigationInPage:reInitNoClick');
	}

	stop() {}
}
